import React from "react"
import { Helmet } from "react-helmet-async"
import { Container } from "react-bootstrap"
import VesselTrackingMain from "./VesselTrackingMain"
function VesselTrackingWrapper() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Helmet>
          <title>Vessel Tracking | Market Manager Platform</title>
        </Helmet>
        <Container fluid>
          <div className="main-content_inner">
            <div className="PrevetWrapper_BreadcrumbBar">
              <h4>Vessel Tracking</h4>
            </div>
            <VesselTrackingMain/>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default VesselTrackingWrapper
